import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

class PublicWebContentService {
  /**
   * Get all content for admin management
   */
  static async getAllContent(token) {
    try {
      const response = await axios.get(`${API_BASE_URL}/admin/public-web/content`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data.data;
    } catch (error) {
      console.error('Error fetching all content:', error);
      throw error;
    }
  }

  /**
   * Create or update content
   */
  static async upsertContent(contentData, token) {
    try {
      const response = await axios.post(`${API_BASE_URL}/admin/public-web/content`, contentData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data.data;
    } catch (error) {
      console.error('Error upserting content:', error);
      throw error;
    }
  }

  /**
   * Toggle content status
   */
  static async toggleContentStatus(id, token) {
    try {
      const response = await axios.put(
        `${API_BASE_URL}/admin/public-web/content/${id}/toggle-status`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      return response.data.data;
    } catch (error) {
      console.error('Error toggling content status:', error);
      throw error;
    }
  }

  /**
   * Delete content
   */
  static async deleteContent(id, token) {
    try {
      const response = await axios.delete(`${API_BASE_URL}/admin/public-web/content/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error deleting content:', error);
      throw error;
    }
  }

  /**
   * Get content statistics
   */
  static async getContentStats() {
    try {
      const response = await axios.get(`${API_BASE_URL}/public-web/stats`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching content stats:', error);
      throw error;
    }
  }
}

export default PublicWebContentService;
